// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

//引入element
import Element from 'element-ui';

//引入中英文切换插件vue-i18n
import VueI18n from 'vue-i18n'
//引入store
import store from './store'
//y引入swiper样式
import 'swiper/swiper-bundle.min.css'
//引入utils
import utils from './utils/utils'

import '@/utils/vFilter.js'

import vueSeamlessScroll from '@/components/vueSeamlessScroll'
import TabMenu from '@/components/tabMenu'

//引入百度地图
// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, {
//   ak: "oeOmZLrkz8tvdd6DB3zIocqsepF4KN0G"
// })

Vue.use(VueI18n) // 挂载
const i18n = new VueI18n({
  locale: 'zh-CN',    // 语言标识
  messages: {
    'zh-CN': require('./utils/i18n/langs/zh'),   // 中文版zh.js文件路径
    'en-US': require('./utils/i18n/langs/en')    // 英文版en.js文件路径
  },
  silentTranslationWarn: true
})

Vue.use(Element);
Vue.component('vueSeamlessScroll',vueSeamlessScroll)
Vue.component('TabMenu',TabMenu)

Vue.config.productionTip = false
Vue.prototype.$utils = utils;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js